import React, { Fragment } from 'react'

import ThemeMenuTwo from '../../components/header/ThemeMenuTwo'
import ThemeBannerTwo from '../../components/theme-banner/ThemeBannerTwo'
import FeatureThree from '../../components/feature/FeatureThree'
import BlockStyleThree from '../../components/block/BlockStyleThree'
import CounterTwo from '../../components/counter/CounterTwo'
import FeatureFour, { FEATURE_FOUR_DEFAULT_ITEMS } from '../../components/feature/FeatureFour'
import CaseSliderOne, {
    CASE_SLIDER_B2C_ECOMMERCE_ITEM,
    CASE_SLIDER_B2C_MOBILE_ITEM,
    CASE_SLIDER_BLOCKCHAIN_ITEM,
    CASE_SLIDER_DIGITAL_ASSETS_EXCHANGE_ITEM,
    CASE_SLIDER_PREMIUM_AUTO_CONCIERGE_ITEM,
} from '../../components/case-study/CaseSliderOne'
import BlockStylFive from '../../components/block/BlockStylFive'
import FeedbackTwo from '../../components/testimonial/FeedbackTwo'
import FooterTwo from '../../components/footer/FooterTwo'

const SOFTWARE_DEV_CASE_SLIDER_ITEMS = [
    CASE_SLIDER_PREMIUM_AUTO_CONCIERGE_ITEM,
    CASE_SLIDER_DIGITAL_ASSETS_EXCHANGE_ITEM,
    CASE_SLIDER_BLOCKCHAIN_ITEM,
    CASE_SLIDER_B2C_ECOMMERCE_ITEM,
    CASE_SLIDER_B2C_MOBILE_ITEM,
]

/** 소프트웨어 개발 페이지: 코담디자인(캐릭터·산업·제품) 카드 제외 */
const SOFTWARE_DEV_FEATURE_ITEMS = FEATURE_FOUR_DEFAULT_ITEMS.filter((item) => !item.anchorId)

const SoftwareDevelopment = () => {
    return (
        <Fragment>
            <div className="main-page-wrapper">

                <ThemeMenuTwo />
                <ThemeBannerTwo
                    heroImage1="/assets/img/hero/software-development-hero.png"
                    heroImage1Alt="글로벌 금융 비즈니스 플랫폼 UI와 서비스 특장점을 보여 주는 소프트웨어 개발 히어로 이미지"
                    heroImage2="/assets/img/hero/software-development-hero-circle.webp"
                    heroImage2Alt="소프트웨어 개발 히어로 원형 비주얼"
                />

                <section className="codam-feature pt-150 pb-30 pt-lg-120">
                    <div className="container">
                        <FeatureThree />
                    </div>
                </section>

                <section className="about-codam-two pt-75 pb-105 pt-lg-40 pb-lg-20 pt-md-30 pb-md-15">
                    <img className="about-shape shape-1b" src="assets/img/shape/star-3b.svg" alt="배경 도형" />
                    <img className="about-shape shape-2b" src="assets/img/shape/star-4b.svg" alt="배경 도형" />
                    <img className="about-shape shape-3b d-none d-md-inline-block" src="assets/img/shape/star-2.svg" alt="배경 도형" />
                    <img className="about-shape shape-4b" src="assets/img/shape/star-5b.svg" alt="배경 도형" />
                    <div className="container">
                        <div className="row gx-4 gx-xxl-5 align-items-center">
                            <div className="col-xxl-5 col-xl-4 col-md-6 order-2" data-aos="fade-up" data-aos-delay={100}>
                                <div className="about-img-wrapper-two about-img-wrapper-two--slot-500x650 text-lg-end position-relative mb-45">
                                    <img
                                        className="main-img"
                                        src="/assets/img/about/software-development-enterprise-operations.png"
                                        alt="개발팀 협업과 대시보드·코딩 환경을 보여 주는 엔터프라이즈 소프트웨어 구축 현장"
                                        loading="lazy"
                                        decoding="async"
                                    />
                                    <img className="shape-one" src="assets/img/shape/line-round-4a.svg" alt="배경 도형" />
                                </div>
                            </div>
                            <div className="col-xxl-4 col-xl-4 col-md-6 order-1" data-aos="fade-up" data-aos-delay={100}>
                                <BlockStyleThree />
                            </div>
                            <div className="col-xxl-3 col-xl-4 order-3" data-aos="fade-left" data-aos-delay={100}>
                                <CounterTwo />
                            </div>
                        </div>
                    </div>
                </section>

                <section className="our-services codam-services-page service-bg-two pt-95 pb-50 pt-lg-50 pb-lg-15">
                    <div className="container">
                        <div className="row gx-4 gx-xxl-5 align-items-center justify-content-center">
                            <div className="col-xl-5 col-lg-6 col-md-8">
                                <div className="section-title text-center mb-55">
                                    <h2 className="sect-title mb-25" data-aos="fade-up">핵심 소프트웨어 개발 서비스</h2>
                                    <p data-aos="fade-up" data-aos-delay={100}>기업 운영 환경에 맞는 실무 중심 소프트웨어를 구축합니다. 확장성과 안정성을 기본 원칙으로 개발합니다.</p>
                                </div>
                            </div>
                        </div>
                        <FeatureFour items={SOFTWARE_DEV_FEATURE_ITEMS} />
                    </div>
                </section>

                <section className="latest-case-work slick-nav blog-slick pt-145 pb-150 pt-lg-60 pb-lg-120">
                    <img className="case-shape shape-1b d-none d-lg-inline-block" src="assets/img/shape/star-3b.svg" alt="배경 도형" />
                    <img className="case-shape shape-2b d-none d-lg-inline-block" src="assets/img/shape/star-4b.svg" alt="배경 도형" />
                    <img className="case-shape shape-3b d-none d-lg-inline-block" src="assets/img/shape/star-2.svg" alt="배경 도형" />
                    <img className="case-shape shape-4b d-none d-lg-inline-block" src="assets/img/shape/star-5b.svg" alt="배경 도형" />
                    <div className="container">
                        <div className="row gx-4 gx-xxl-5 align-items-center">
                            <div className="col-xl-5 col-lg-6 col-md-8">
                                <div className="section-title mb-55 text-md-start text-center">
                                    <h6 className="sub-title mb-20" data-aos="fade-up">구축 사례</h6>
                                    <h2 className="sect-title mb-25" data-aos="fade-up" data-aos-delay={100}>실제 완료된 주요 프로젝트</h2>
                                </div>
                            </div>
                        </div>
                        <CaseSliderOne items={SOFTWARE_DEV_CASE_SLIDER_ITEMS} />
                    </div>
                </section>

                <section className="codam-wrok-process pt-140 pb-30 pt-lg-55">
                    <div className="container">
                        <div className="row gx-4 gx-xxl-5">
                            <div className="col-lg-12">
                                <div className="section-title text-center mb-55">
                                    <h6 className="sub-title mb-20">진행 방식</h6>
                                    <h2 className="sect-title">CODAM 개발 프로세스</h2>
                                </div>
                            </div>
                        </div>
                        <div className="row gx-4 gx-xxl-5 align-items-center">
                            <div className="col-xl-7 col-lg-6">
                                <div className="process-img-wrapper process-img-wrapper--slot-610x628 mb-45">
                                    <img
                                        src="/assets/img/work/software-development-process.png"
                                        alt="화이트보드 기획·UI 설계와 협업 개발을 진행하는 CODAM 개발 프로세스"
                                        loading="lazy"
                                        decoding="async"
                                    />
                                    <div className="call-box">
                                        <div className="icon">
                                            <img src="assets/img/icon/icon-27b.svg" alt="문의 아이콘" />
                                        </div>
                                        <h3 className="sect-title-two">지금 프로젝트를<br/>검토해보세요</h3>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-5 col-lg-6">
                                <BlockStylFive />
                            </div>
                        </div>
                    </div>
                </section>

                <section className="client-feedback feedback-bg pt-70 pb-110 pb-lg-60">
                    <div className="container">
                        <div className="row gx-4 gx-xxl-5">
                            <div className="col-lg-12">
                                <div className="section-title text-center mb-55">
                                    <h6 className="sub-title mb-20">고객 후기</h6>
                                    <h2 className="sect-title">고객사가 전하는 CODAM 경험</h2>
                                </div>
                            </div>
                        </div>
                        <FeedbackTwo />
                    </div>
                </section>

                <FooterTwo />
            </div>
        </Fragment>
    )
}

export default SoftwareDevelopment
